// --------------------------------------------------------------------------
// formValidate.js
// --------------------------------------------------------------------------
// Uses Parsley.js to validate forms
// --------------------------------------------------------------------------

RN.formValidate = function() {

    'use strict';

    function init() {
        var form = byBehaviour('form-validate');
        if (form.length > 0 ){
            form.parsley();
        }
    }

    return {
        init: init
    };

}();